import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-nextjs';

interface HomepageSublayoutProps {
  rendering?: ComponentRendering & { params?: ComponentParams };
  params?: ComponentParams;
}

export const Default = (props?: HomepageSublayoutProps) => {
  return props?.rendering && <Placeholder name="homepage-sublayout" rendering={props.rendering} />;
};
